import {trackOspError} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackOspError = () => {
  const {TrackingClient} = useTracking();

  return (message: string) => {
    const trackingData = trackOspError({message});

    TrackingClient.track(() => trackingData);
  };
};
